import React from "react"
import "./App.css"

class Login extends React.Component {
    state = {
        email: "",
        password: "",
        errorMessage: "",
    }

    login = async () => {
        const res = await fetch(
            `https://feedsapi.baida.dev:8080/login?email=${encodeURIComponent(
                this.state.email
            )}&password=${encodeURIComponent(this.state.password)}`,
            {
                method: "POST",
                headers: {},
            }
        )
            .then((res) => res.json())
            .catch((e) => {
                console.log(e)
                return { error: "Something has gone wrong" }
            })

        if (res.error) {
            this.setState({ errorMessage: res.error })
        } else {
            this.props.setToken(res.token)
        }
    }

    signup = async () => {
        const res = await fetch(
            `https://feedsapi.baida.dev:8080/user?email=${encodeURIComponent(
                this.state.email
            )}&password=${encodeURIComponent(this.state.password)}`,
            {
                method: "POST",
                body: JSON.stringify({ Collections: {} }),
                headers: {},
            }
        )
            .then((res) => res.json())
            .catch((e) => {
                console.log(e)
                return { error: "Something has gone wrong" }
            })

        if (res.error) {
            this.setState({ errorMessage: res.error })
        } else {
            this.props.setToken(res.token)
        }
    }

    render() {
        return (
            <div className="login-page">
                <div className="header">
                    <h2 className="header-title">The Weekly Digest</h2>
                    <div className="header-buttons">
                        <span className="header-date">
                            {new Date().getDate().toString().padStart(2, "0") +
                                "." +
                                (new Date().getMonth() + 1)
                                    .toString()
                                    .padStart(2, "0") +
                                "." +
                                new Date().getFullYear()}
                        </span>
                    </div>
                </div>
                <p
                    style={{
                        width: "300px",
                        margin: "64px auto 64px auto",
                        textAlign: "left",
                    }}
                >
                    A free service that every Saturday sends you an email with
                    all the new posts from blogs you follow.
                </p>
                <div className="form">
                    <label for="femail">Email:&nbsp;</label>
                    <input
                        type="text"
                        id="femail"
                        name="femail"
                        value={this.state.email}
                        style={{ width: "225px", marginBottom: "8px" }}
                        onChange={(e) =>
                            this.setState({ email: e.target.value })
                        }
                    />
                    <br />

                    <label for="fpassword">Password:&nbsp;</label>
                    <input
                        type="password"
                        id="fpassword"
                        name="fpassword"
                        value={this.state.password}
                        onChange={(e) =>
                            this.setState({ password: e.target.value })
                        }
                    />
                    {this.state.errorMessage && (
                        <p>{this.state.errorMessage}</p>
                    )}
                </div>
                <button onClick={this.login} className="login-button">
                    Log In
                </button>
                <button onClick={this.signup} className="signup-button">
                    Sign Up
                </button>
                <br />
            </div>
        )
    }
}

class Main extends React.Component {
    state = {
        Collections: [],
        errorMessage: "",
        saving: false,
        saveEnabled: false,
    }

    async componentDidMount() {
        const res = await fetch("https://feedsapi.baida.dev:8080/user", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + this.props.token,
            },
        })
            .then((res) => res.json())
            .catch((e) => {
                console.log(e)
                return { error: "Something went wrong" }
            })

        if (res.error) {
            this.setState({ errorMessage: res.error })
        } else {
            this.setState({ Collections: res.Collections })
        }
    }

    updateFeedName = (newName, collectionName, feedIndex) => {
        this.setState((oldState) => {
            const collections = JSON.parse(JSON.stringify(oldState.Collections))
            collections[collectionName][feedIndex].Name = newName

            return { Collections: collections, saveEnabled: true }
        })
    }
    updateFeedLink = (newLink, collectionName, feedIndex) => {
        this.setState((oldState) => {
            const collections = JSON.parse(JSON.stringify(oldState.Collections))
            collections[collectionName][feedIndex].FeedLink = newLink

            return { Collections: collections, saveEnabled: true }
        })
    }
    deleteFeed = (collectionName, feedIndex) => {
        this.setState((oldState) => {
            const collections = JSON.parse(JSON.stringify(oldState.Collections))
            collections[collectionName].splice(feedIndex, 1)

            return { Collections: collections, saveEnabled: true }
        })
    }
    deleteCollection = (collectionName) => {
        this.setState((oldState) => {
            const collections = JSON.parse(JSON.stringify(oldState.Collections))
            delete collections[collectionName]

            return { Collections: collections, saveEnabled: true }
        })
    }
    addFeed = (collectionName) => {
        this.setState((oldState) => {
            const collections = JSON.parse(JSON.stringify(oldState.Collections))
            collections[collectionName].push({
                Name: "",
                FeedLink: "",
            })

            return { Collections: collections, saveEnabled: true }
        })
    }
    updateCollectionName = (collectionName, newName) => {
        this.setState((oldState) => {
            const collections = JSON.parse(JSON.stringify(oldState.Collections))
            Object.defineProperty(
                collections,
                newName,
                Object.getOwnPropertyDescriptor(collections, collectionName)
            )
            delete collections[collectionName]

            return { Collections: collections, saveEnabled: true }
        })
    }
    addCollection = () => {
        this.setState((oldState) => {
            const collections = JSON.parse(JSON.stringify(oldState.Collections))
            collections["An Empty Collection"] = []

            return { Collections: collections, saveEnabled: true }
        })
    }

    save = async () => {
        const res = await fetch("https://feedsapi.baida.dev:8080/user", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.props.token,
            },
            body: JSON.stringify({
                Collections: this.state.Collections,
            }),
        })
            .then(() => {
                this.setState({ saving: false, saveEnabled: false })
            })
            .catch((e) => {
                console.log(e)
                this.setState({ errorMessage: "Something has gone wrong" })
            })
    }

    render() {
        return (
            <div className="main">
                <div className="header">
                    <h2 className="header-title">The Weekly Digest</h2>
                    <div className="header-buttons">
                        {this.state.saving ? (
                            <span className="saving-message">Saving</span>
                        ) : (
                            this.state.saveEnabled && (
                                <button
                                    className="save-button"
                                    onClick={this.save}
                                >
                                    Save
                                </button>
                            )
                        )}
                        <button
                            className="logout-button"
                            onClick={this.props.logOut}
                        >
                            Log Out
                        </button>
                    </div>
                </div>
                {this.state.errorMessage && <p>{this.state.errorMessage}</p>}
                {!this.state.Collections["An Empty Collection"] && (
                    <button
                        className="add-collection"
                        onClick={() => this.addCollection()}
                    >
                        Add Collection
                    </button>
                )}
                {!this.state.errorMessage &&
                    Object.entries(this.state.Collections)
                        .sort((a, b) =>
                            a[0] > b[0] ? 1 : a[0] === b[0] ? 0 : -1
                        )
                        .map(([name, feeds]) => (
                            <div className="collection">
                                <div className="collection-title">
                                    <input
                                        value={name}
                                        className="collection-name"
                                        onChange={(e) =>
                                            this.updateCollectionName(
                                                name,
                                                e.target.value
                                            )
                                        }
                                    />
                                    <button
                                        className="delete-collection"
                                        onClick={() =>
                                            this.deleteCollection(name)
                                        }
                                    >
                                        X
                                    </button>
                                </div>
                                {feeds.map((feed, feedIndex) => (
                                    <p>
                                        Name:&nbsp;
                                        <input
                                            className="feed-name"
                                            value={feed.Name}
                                            onChange={(e) =>
                                                this.updateFeedName(
                                                    e.target.value,
                                                    name,
                                                    feedIndex
                                                )
                                            }
                                        />
                                        Feed:&nbsp;
                                        <input
                                            className="feed-link"
                                            value={feed.FeedLink}
                                            onChange={(e) =>
                                                this.updateFeedLink(
                                                    e.target.value,
                                                    name,
                                                    feedIndex
                                                )
                                            }
                                        />
                                        <button
                                            className="delete-feed"
                                            onClick={() =>
                                                this.deleteFeed(name, feedIndex)
                                            }
                                        >
                                            X
                                        </button>
                                    </p>
                                ))}
                                <button
                                    className="add-feed"
                                    onClick={() => this.addFeed(name)}
                                >
                                    Add Feed
                                </button>
                            </div>
                        ))}
            </div>
        )
    }
}

export default class App extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            token: "",
        }

        if (typeof localStorage !== "undefined") {
            const token = localStorage.getItem("token")

            if (token) {
                this.state.token = token
            }
        }
    }

    setToken = (token) => {
        if (typeof localStorage !== "undefined") {
            localStorage.setItem("token", token)
        }
        this.setState({ token })
    }

    logOut = () => {
        this.setState({ token: undefined })
        localStorage.removeItem("token")
    }

    render() {
        return (
            <div className="App">
                {!this.state.token && <Login setToken={this.setToken} />}
                {this.state.token && (
                    <Main token={this.state.token} logOut={this.logOut} />
                )}
            </div>
        )
    }
}
